import { DeveloperPhoneRole } from "@/types/hiddenPhones.types";

export const getDeveloperRoleBgClass = (role: DeveloperPhoneRole): string => {
  switch (role) {
    case DeveloperPhoneRole.OWNER:
      return "bg-[#F18F8F]";

    case DeveloperPhoneRole.AGENT:
      return "bg-[#BFCCFF]";

    case DeveloperPhoneRole.ASSISTANT:
      return "bg-[#BAE197]";

    case DeveloperPhoneRole.OTHER:
    default:
      return "bg-[#E6E6E6]";
  }
};
